import Accordion, { AccordionTheme } from 'components/molecules/Accordion';

import TypographyMui5 from '@mui/material/Typography';
import { styled as styledMui5 } from '@mui/material/styles';
import { Theme as ThemeMui5 } from '@mui/material/styles/createTheme';
import { SxProps } from '@mui/system';
import { Tab, TabPanel, Tabs, TabsContainer } from 'components/atoms/Tabs';
import { CarFeatures } from 'containers/deal/components/CarFeatures';
import React, { useEffect } from 'react';
import { CarFeature } from 'shared/types/models';
import { moneyFormat } from 'shared/utils/functions';
import { fixBR } from './fixBR';

type Props = {
  options: Array<{ name?: string; details?: string[]; msrpMax?: number }>;
  showDescription: boolean;
  features: CarFeature[];
};

const UnorderedList = styledMui5('ul')(
  ({ theme }) => `
  margin: ${theme.spacing(0, 2)};
  padding: 0;`,
);

const panelStyles: SxProps<ThemeMui5> = (theme) => ({
  '&.MuiBox-root': {
    maxWidth: theme.spacing(50),
  },
});

const accordionItemHeaderStyles: SxProps<ThemeMui5> = {
  '&.MuiAccordionSummary-root': {
    backgroundColor: 'transparent !important',
  },
};

export default function VehicleOptions({
  options,
  showDescription = true,
  features,
}: Props): JSX.Element {
  const [, setValue] = React.useState(0);

  // This is a dirty hack to force component to rerender and recalculate tabs width
  useEffect(() => {
    setTimeout(() => {
      setValue((prev) => prev + 1);
    }, 200);
  }, []);

  return (
    <TabsContainer>
      <Tabs indicatorColor='primary' textColor='primary' value={0}>
        <Tab value={0} label='Vehicle installed options' />
        <Tab value={1} label='Features' />
      </Tabs>
      <TabPanel index={0} sx={panelStyles}>
        {!options.length && (
          <TypographyMui5 variant='body1' color='textSecondary'>
            There are no options installed.
          </TypographyMui5>
        )}
        <Accordion
          itemHeaderSx={accordionItemHeaderStyles}
          theme={AccordionTheme.White}
          items={options.map((option) => ({
            id: option.name,
            header: {
              text: fixBR(option.name),
              additionalInfo: moneyFormat(option.msrpMax),
            },
            body: showDescription ? (
              <UnorderedList>
                {(option.details || []).map((detail, index) => {
                  return <li key={index}>{detail}</li>;
                })}
              </UnorderedList>
            ) : null,
          }))}
        />
      </TabPanel>
      <TabPanel index={1} sx={panelStyles}>
        <CarFeatures features={features} />
      </TabPanel>
    </TabsContainer>
  );
}
